function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { getNullLogger, ensureUniformSiteName } from '@uniformdev/common';
import { getSubscriptionManager, createUniformUnsubscribe } from '@uniformdev/optimize-common-sitecore';
import { getSitecoreContextDataReader } from './contextReaders';
import { getNullTestManager } from '../testManagers';
var axios = require('axios').default;
function getDefaultDataFetcher() {
  var fetcher = function fetcher(url, data) {
    return axios({
      url: url,
      method: data ? 'POST' : 'GET',
      headers: {
        'Accept-ESI': 'true'
      },
      data: data,
      // note: axios needs to use `withCredentials: true` in order for Sitecore cookies to be included in CORS requests
      // which is necessary for analytics and such
      withCredentials: true
    });
  };
  return fetcher;
}
function getDefaultDataFetcherReader(contextDataSource, logger) {
  if (!logger) logger = getNullLogger();
  if (contextDataSource == 'jss-esi') {
    var reader = function reader(rendering, data, logger) {
      var _a, _b, _c;
      if (!logger) logger = getNullLogger();
      if (!data) {
        logger.debug('Sitecore ESI personalization manager - No data was provided to the data fetcher result reader.');
        return;
      }
      var placeholders = (_c = (_b = (_a = data.sitecore) === null || _a === void 0 ? void 0 : _a.route) === null || _b === void 0 ? void 0 : _b.placeholders) !== null && _c !== void 0 ? _c : {};
      var keys = Object.keys(placeholders);
      for (var i = 0; i < keys.length; i++) {
        var placeholder = placeholders[keys[i]];
        var index = placeholder.findIndex(function (r) {
          return r.uid == rendering.uid;
        });
        if (index != -1) {
          return placeholder[index];
        }
      }
      return;
    };
    return reader;
  }
  logger.error('Sitecore ESI personalization manager - No data fetcher reader can be resolved for the specified context data source.', {
    contextDataSource: contextDataSource
  });
  return;
}
function getTriggers(definitions) {
  var triggers = {};
  var hasTriggers = false;
  Object.keys(definitions).forEach(function (renderingUid) {
    var dependencies = definitions[renderingUid].dependencies;
    if (Array.isArray(dependencies)) {
      hasTriggers = true;
      triggers[renderingUid] = dependencies;
    }
  });
  return hasTriggers ? triggers : undefined;
}
function flattenArrays(source, target) {
  if (!Array.isArray(source)) {
    return;
  }
  for (var i = 0; i < source.length; i++) {
    var value = source[i];
    if (value == undefined || value == null) {
      continue;
    }
    if (Array.isArray(value)) {
      flattenArrays(value, target);
      continue;
    }
    if (target.indexOf(value) == -1) {
      target.push(value);
    }
  }
}
/**
 * Gets a Sitecore personalization manager.
 * @param args
 */
export function getSitecoreEsiPersonalizationManager(args) {
  var _this = this;
  var _a;
  var id = "SC_ESI_PERS_MGR";
  var _args$disabled = args.disabled,
    disabled = _args$disabled === void 0 ? false : _args$disabled,
    contextData = args.contextData,
    _args$contextDataSour = args.contextDataSource,
    contextDataSource = _args$contextDataSour === void 0 ? "jss-esi" : _args$contextDataSour,
    _args$logger = args.logger,
    logger = _args$logger === void 0 ? getNullLogger() : _args$logger,
    _args$dataFetcher = args.dataFetcher,
    dataFetcher = _args$dataFetcher === void 0 ? getDefaultDataFetcher() : _args$dataFetcher,
    _args$getDataFetcherU = args.getDataFetcherUrl,
    getDataFetcherUrl = _args$getDataFetcherU === void 0 ? getDefaultGetDataFetcherUrl : _args$getDataFetcherU;
  logger.debug("Get sitecore ESI personalization manager - START.", {
    args: args
  });
  //
  //
  var reader = getSitecoreContextDataReader(contextDataSource);
  var page = reader === null || reader === void 0 ? void 0 : reader.getPageDetails(contextData);
  //
  //
  var definitions = reader === null || reader === void 0 ? void 0 : reader.getDefinitions(contextData);
  if (!definitions) {
    logger.debug("Get sitecore ESI personalization manager -   * No dependency-based personalization definitions were resolved from the context data. Only origin-based personalization will be used. Returning a disabled personalization manager.", {
      args: args
    });
    logger.debug("Get sitecore ESI personalization manager - END.", {
      args: args
    });
    return getDisabledSitecoreEsiPersonalizationManager();
  }
  logger.debug("Get sitecore ESI personalization manager -   * Dependency-based personalization definitions were resolved, so get the appropriate personalization triggers.", {
    definitions: definitions
  });
  var triggers = getTriggers(definitions);
  if (!triggers) {
    logger.debug("Get sitecore ESI personalization manager -   * No personalization triggers were resolved. All personalization will be origin-based.", {
      definitions: definitions
    });
  }
  //
  //
  var testManager = (_a = args.testManager) !== null && _a !== void 0 ? _a : getNullTestManager();
  if (!args.testManager) {
    logger.debug("Get sitecore ESI personalization manager -   * No test manager was specified in args, so create a dummy manager. Testing is effectively disabled.", {
      args: args
    });
  } else {
    logger.debug("Get sitecore ESI personalization manager -   * Test manager was resolved.", {
      testManager: testManager
    });
  }
  //
  //
  var subscriptions = getSubscriptionManager("".concat(id, "_SUBS"), false, logger);
  //
  //
  function getDefaultGetDataFetcherUrl(item, rendering) {
    var sitecoreApiKey = args.sitecoreApiKey,
      sitecoreSiteName = args.sitecoreSiteName;
    var scSite = ensureUniformSiteName(sitecoreSiteName);
    var url = "/sitecore/api/layout/render/jss?item=".concat(item, "&sc_apikey=").concat(sitecoreApiKey, "&sc_site=").concat(scSite, "&rendering=").concat(rendering);
    if (!sitecoreApiKey) {
      logger.error("Sitecore ESI personalization manager - The default getDataFetcherUrl is used in the personalization manager, but no Sitecore API key was specified. Layout Service calls will likely fail.", {
        url: url
      });
    }
    if (!scSite) {
      logger.error("Sitecore ESI personalization manager - The default getDataFetcherUrl is used in the personalization manager, but no Sitecore site name was specified. Layout Service may call if Sitecore depends on this value for site resolution.", {
        url: url
      });
    }
    return url;
  }
  //
  //
  function doPersonalize(rendering, triggeredTriggers) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
      var dataFetcherReader, dependencies, atLeastOneDependencyIsMet, fetchUrl, dataFetcherResult, pzData, esiData, originActivity, context, result, includedInTest, e, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (rendering) {
              _context.n = 1;
              break;
            }
            logger.error('Sitecore ESI personalization manager -   * No rendering was specified.', {
              id: id
            });
            return _context.a(2);
          case 1:
            if (!disabled) {
              _context.n = 2;
              break;
            }
            logger.debug('Sitecore ESI personalization manager -   * Personalization is disabled.', {
              id: id,
              rendering: rendering.uid
            });
            return _context.a(2);
          case 2:
            if (triggers) {
              _context.n = 3;
              break;
            }
            logger.debug('Sitecore ESI personalization manager -   * No rendering triggers map were specified.', {
              id: id,
              rendering: rendering.uid
            });
            return _context.a(2);
          case 3:
            if (dataFetcher) {
              _context.n = 4;
              break;
            }
            logger.error('Sitecore ESI personalization manager -   * No dataFetcher implementation was provided.', {
              id: id,
              rendering: rendering.uid
            });
            return _context.a(2);
          case 4:
            dataFetcherReader = (_a = args.dataFetcherReader) !== null && _a !== void 0 ? _a : getDefaultDataFetcherReader(contextDataSource);
            if (dataFetcherReader) {
              _context.n = 5;
              break;
            }
            logger.error('Sitecore ESI personalization manager -   * No dataFetcher reader implementation was provided.', {
              id: id,
              rendering: rendering.uid
            });
            return _context.a(2);
          case 5:
            if (triggeredTriggers) {
              _context.n = 6;
              break;
            }
            logger.debug('Sitecore ESI personalization manager -   * No triggers provided for personalization.', {
              id: id,
              rendering: rendering.uid
            });
            return _context.a(2);
          case 6:
            //
            //With client-side personalization, all of the dependencies 
            //must be met in order for personalization to be performed
            //because personalization can be performed on a per-rule
            //basis.
            //
            //ESI personalization is different because it is performed
            //on a per-component basis. This means that as long as at
            //least one dependency is met, ESI personalization should
            //run.
            dependencies = [];
            flattenArrays(triggers[rendering.uid], dependencies);
            //
            //
            if (!(dependencies.length > 0)) {
              _context.n = 8;
              break;
            }
            atLeastOneDependencyIsMet = dependencies.some(function (dependency) {
              return triggeredTriggers.includes(dependency);
            });
            if (atLeastOneDependencyIsMet) {
              _context.n = 7;
              break;
            }
            logger.debug('Sitecore ESI personalization manager -   * At least one rendering dependency must be met in order to fetch personalized data.', {
              id: id,
              dependencies: dependencies,
              triggers: triggers,
              page: page,
              rendering: rendering.uid
            });
            return _context.a(2);
          case 7:
            logger.debug('Sitecore ESI personalization manager -   * At least one rendering dependency was met, so personalized data will be fetched.', {
              id: id,
              dependencies: dependencies,
              triggers: triggers,
              page: page,
              rendering: rendering.uid
            });
          case 8:
            logger.debug('Sitecore ESI personalization manager -   * Setting rendering state to loading.', {
              id: id,
              page: page,
              rendering: rendering.uid
            });
            //Set to loading before applying the rules
            subscriptions.publish({
              component: rendering.uid,
              isLoading: true,
              page: page,
              type: 'state-changed',
              when: new Date()
            });
            _context.p = 9;
            if (page === null || page === void 0 ? void 0 : page.id) {
              _context.n = 10;
              break;
            }
            logger.error('Sitecore ESI personalization manager -   * No page id is available, so no personalized data will be fetched.', {
              id: id,
              page: page,
              rendering: rendering.uid
            });
            return _context.a(2);
          case 10:
            fetchUrl = getDataFetcherUrl(page.id, rendering.uid);
            logger.debug('Sitecore ESI personalization manager -   * Fetching personalized data.', {
              id: id,
              fetchUrl: fetchUrl,
              rendering: rendering.uid
            });
            _context.n = 11;
            return dataFetcher(fetchUrl);
          case 11:
            dataFetcherResult = _context.v;
            pzData = dataFetcherReader(rendering, dataFetcherResult === null || dataFetcherResult === void 0 ? void 0 : dataFetcherResult.data, logger);
            if (pzData) {
              _context.n = 12;
              break;
            }
            logger.error('Sitecore ESI personalization manager -   * Data fetcher reader returned no data.', {
              id: id,
              fetchUrl: fetchUrl,
              pzData: pzData,
              rendering: rendering.uid
            });
            return _context.a(2);
          case 12:
            //
            //
            esiData = pzData;
            originActivity = pzData === null || pzData === void 0 ? void 0 : pzData.personalization;
            if (originActivity) {
              _context.n = 13;
              break;
            }
            logger.debug('Sitecore ESI personalization manager -   * Data fetcher returned data without origin-based personalization.', {
              id: id,
              fetchUrl: fetchUrl,
              pzData: pzData,
              rendering: rendering.uid
            });
            return _context.a(2);
          case 13:
            logger.debug('Sitecore ESI personalization manager -   * Data fetcher returned data with origin-based personalization.', {
              id: id,
              fetchUrl: fetchUrl,
              pzData: pzData,
              rendering: rendering.uid
            });
            context = rendering;
            result = evaluatePersonalization({
              activity: originActivity,
              data: esiData,
              logger: logger,
              page: page,
              personalizationContext: context
            });
            includedInTest = (_b = testManager === null || testManager === void 0 ? void 0 : testManager.getIsIncludedInTest()) !== null && _b !== void 0 ? _b : false; //
            //Publish a state-changed event to notify components that
            //personalization is done loading and that there may be
            //changes to render.
            e = {
              activity: originActivity,
              changes: result.changes,
              component: rendering.uid,
              data: esiData,
              includedInTest: includedInTest,
              isLoading: false,
              page: page,
              personalizedData: result.fields,
              type: 'state-changed',
              when: new Date()
            };
            logger.debug('Sitecore ESI personalization manager -   * Personalized data is available for the rendering. Publish the state-changed event so the component can be updated.', {
              id: id,
              manager: subscriptions.id,
              result: result,
              rendering: rendering.uid,
              event: e,
              me: manager
            });
            subscriptions.publish(e);
            _context.n = 15;
            break;
          case 14:
            _context.p = 14;
            _t = _context.v;
            logger.error('Sitecore ESI personalization manager -   * Error occured while loading personalized data. Publish the state-changed event to indicate loading is finished.', {
              id: id,
              error: _t,
              rendering: rendering.uid
            });
            subscriptions.publish({
              component: rendering.uid,
              error: _t,
              isLoading: false,
              page: page,
              type: 'state-changed',
              when: new Date()
            });
          case 15:
            return _context.a(2);
        }
      }, _callee, null, [[9, 14]]);
    }));
  }
  var manager = {
    id: id,
    disabled: disabled,
    page: page,
    subscriptions: subscriptions,
    triggers: triggers,
    testManager: args.testManager,
    onTrigger: function onTrigger(trigger, rendering) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              logger.debug("Sitecore ESI personalization manager - START: onTrigger", {
                id: id,
                trigger: trigger,
                rendering: rendering.uid
              });
              _context2.n = 1;
              return doPersonalize(rendering, [trigger]);
            case 1:
              logger.debug("Sitecore ESI personalization manager - END: onTrigger", {
                id: id,
                trigger: trigger,
                rendering: rendering.uid
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
    },
    personalize: function personalize(rendering) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              logger.debug("Sitecore ESI personalization manager - START: personalize", {
                id: id,
                rendering: rendering.uid
              });
              _context3.n = 1;
              return doPersonalize(rendering);
            case 1:
              logger.debug("Sitecore ESI personalization manager - END: personalize", {
                id: id,
                rendering: rendering.uid
              });
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }));
    }
  };
  logger.debug("Get sitecore ESI personalization manager - END.", {
    args: args,
    manager: manager
  });
  return manager;
}
function evaluatePersonalization(_ref) {
  var data = _ref.data,
    logger = _ref.logger,
    page = _ref.page,
    personalizationContext = _ref.personalizationContext;
  var _a, _b;
  var changes = (_b = (_a = data === null || data === void 0 ? void 0 : data.personalization) === null || _a === void 0 ? void 0 : _a.changes) !== null && _b !== void 0 ? _b : {};
  var component = getComponent(personalizationContext);
  var fieldsAfter = data.fields;
  var result = {
    changes: changes,
    component: component,
    data: data,
    fields: fieldsAfter
  };
  logger.debug('Sitecore ESI personalization manager -   * Component should be personalized.', Object.assign(Object.assign({}, result), {
    item: page
  }));
  return result;
}
function getComponent(context) {
  return {
    id: context.uid,
    description: context.componentName
  };
}
function getDisabledSitecoreEsiPersonalizationManager() {
  var _this2 = this;
  var id = "SC_ESI_PERS_MGR_DISABLED";
  return {
    id: id,
    disabled: true,
    onTrigger: function onTrigger() {
      return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              return _context4.a(2);
          }
        }, _callee4);
      }));
    },
    page: {},
    personalize: function personalize() {
      return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              return _context5.a(2);
          }
        }, _callee5);
      }));
    },
    subscriptions: {
      id: "".concat(id, "_SUBS"),
      publish: function publish(_data) {
        return null;
      },
      subscribe: function subscribe(_type, _callback) {
        return createUniformUnsubscribe(function () {
          return false;
        });
      },
      getSubscribers: function getSubscribers(_type) {
        return [];
      },
      getSubscriptionTypes: function getSubscriptionTypes() {
        return [];
      }
    },
    triggers: {}
  };
}